export default __webpack_public_path__ + "static/media/pic6.673108a6.jpg";